import { toastr } from "react-redux-toastr";
import { getErrorMessage, requestHasError } from "../utils/lib";
import { apiPost, apiPut, apiRequest } from "../utils/request";

export function getGlobalSettings(name="") {
    return function () {
      return apiRequest(`/api/systemsettings?name=${name}`)
        .then(x => {
          if (requestHasError({x})) {
            toastr.error(`Global Setting Error: ${getErrorMessage({x})}`);
          } 
          return x;
        });
      }
  }


  export function updateGlobalSettings(payload) {
    return function () {
      return apiPut("/api/systemsettings", payload)
        .then(x => {
          if (requestHasError({x})) {
            toastr.error(`Update Global Setting Error: ${getErrorMessage({x})}`);
          } 
          return x;
        });
      }
  }


export function getOilTypes(name = "") {
  return function () {
    return apiRequest("/api/tank/oil-types", "GET").then((x) => {
      if (requestHasError({ x })) {
        toastr.error(`Tank Maintenance Error: ${getErrorMessage({ x })}`);
      }
      return x;
    });
  };
}

/**
 * 
 * @param {int} id 
 * @returns 
 */
export function getOilTypeDetails(id = 0) {
  return function () {
    return apiRequest(`/api/tank/oil-types/${id}`, "GET").then((x) => {
      if (requestHasError({ x })) {
        toastr.error(`Tank Maintenance Error: ${x.errors.Message}`);
      }
      return x;
    });
  };
}

/**
 * @typedef CreateOilTypePayload
 * @property {string} name 
 * @property {string} code
 * 
 * @param {CreateOilTypePayload} payload 
 * @returns 
 */
export function createOilType(payload) {
  return function () {
    return apiPost("/api/tank/oil-types", payload, false).then((x) => {
      if (!x.data.ok) {
        toastr.error(`Tank Maintenance Error: ${x.errors.Message}`);
      }
      else {
        toastr.success('Saved');
      }
      return x;
    });
  };
}

/**
 * @typedef UpdateOilTypePayload
 * @property {number} id
 * @property {string} name 
 * @property {string} code
 * @property {boolean} isActive
 * 
 * @param {number} id 
 * @param {UpdateOilTypePayload} payload 
 * @returns 
 */
export function updateOilType(id, payload) {
  return function () {
    toastr.success('Saved');
    return apiPut(`/api/tank/oil-types/${id}`, payload, false).then((x) => {
      if (!x.data.ok) {
        toastr.error(`Tank Maintenance Error: ${x.errors.Message}`);
      }
      return x;
    });
  };
}